// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"marketing-profile_wrapper__8Q65O","content":"marketing-profile_content__3KVyz"};